<template>

  <b-modal size="lg" @shown="initCols" id="downloadModal" title="">
    <!-- modal content start -->
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <h4>Choose your exported document format</h4>
          <p>Approx. 25,000 records</p>
          <div class="document-formats clearfix">
            <div class="chkbox-holder">
              <input type="checkbox" id="checkbox-csv" class="regular-checkbox" />
              <label for="checkbox-csv"></label>
              <span class="ic-csv"></span>
            </div>
            <div class="chkbox-holder">
              <input type="checkbox" id="checkbox-tally" class="regular-checkbox" />
              <label for="checkbox-tally"></label>
              <span class="ic-tally"></span>
            </div>
            <div class="chkbox-holder">
              <input type="checkbox" id="checkbox-xls" class="regular-checkbox" checked />
              <label for="checkbox-xls"></label>
              <span class="ic-xls"></span>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">

          <h4>Select columns to be exported</h4>
          <p>Click on a column name to edit it and drag to re-arrange</p>
          {{transactionColumnsForOrdering}}
          <div class="column-selection">
            <draggable v-model="transactionColumnsForOrdering" :move="reorderColumns">
              <transition-group>

                <div  v-for="(element, key) in transactionColumnsForOrdering" :key="key" class="panel clearfix">
                  <div class="panel-body">
                    <div class="chkbox-holder">
                      <input type="checkbox" :id="'checkbox-'+key" name="columns" class="regular-checkbox" />
                      <label for="checkbox-17">
                      </label>
                    </div>
                    <input type="text" v-model="transactionColumnsForOrdering[key].newVal">
                  </div>
                  <div class="panel-heading">
                    <span class="drag-handle"></span>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <!-- modal content end -->
    <div class="modal-footer">
      <a href="#" class="btn btn-primary">Download</a>
      <DownloadExcel
          class   = "btn btn-primary"
          :data   = "transactionsForDownload"
          :fields = "transactionColumnsForDownload"
          name    = "transactions.xls">
          Download
      </DownloadExcel>
    </div>
  </b-modal>
  <!-- download modal start -->
  <!-- <div class="modal fade" id="download-data" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-centered" role="document">
      <div class="modal-content">

      </div>
    </div>
  </div> -->
  <!-- download modal end -->

</template>

<script>
  import DownloadExcel from 'vue-json-excel'
  import Draggable from 'vuedraggable'

  export default {
    name: 'DownloadModal',
    props: ['transactions'],
    data() {
      return {
        list: ['Foo', 'Bar', 'Baz'],
        transactionColumnsForDownload:{},
        transactionColumnsForOrdering:[],
        transactionsForDownload:[]
      }
    },
    components:{ DownloadExcel, Draggable },
    mounted() {

    },
    methods:{
      initCols(){
        var i = 0
        for(var key in this.transactions[0]){
          this.$set(this.transactionColumnsForOrdering, i, {oldVal:key, newVal:key})
          i++
        }
      },
      reorderColumns: function(evt){
        (evt.draggedContext);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import '../assets/scss/custom.scss';
  /*---------- download screen style ----------*/
  #download-data {
      .modal-dialog {
          width: 100%;
          max-width: $containerWidth - 100;
      }
      .modal-body {
          padding: rem(44px);
      }
      button.close {
          position: absolute;
          top: rem(30px);
          right: rem(30px);
          z-index: 9;
          font-size: rem(36px);
          font-weight: 100;
          color: $darktextcolor;
          opacity: 1;
          outline: none;
      }
      h4 {
          font-size: rem(16px);
          color: $darktextcolor;
          font-weight: 600;
          margin-bottom: rem(5px);
      }
      p {
          font-size: rem(12px);
      }
      .document-formats {
          margin-top: rem(20px);
          .chkbox-holder {
              width: 40%;
              float: left;
              margin: rem(20px) 0;
              label {
                  top: rem(30px);
                  margin-right: rem(15px);
              }
              span {
                  display: inline-block;
                  width: rem(64px);
                  height: rem(80px);
              }
              .ic-csv {
                  background: path("ic-csv.svg", images/icons) no-repeat center;
              }
              .ic-tally {
                  background: path("ic-tally.svg", images/icons) no-repeat center;
              }
              .ic-xls {
                  background: path("ic-xls.svg", images/icons) no-repeat center;
              }
          }
      }

      .modal-footer {
          border-top: none;
          text-align: center;
          a {
              width: rem(358px);
          }
      }

      /*-- draggable panel style --*/
      ul {
          margin-top: rem(35px);
      }
      .panel {
          box-shadow: none;
          border: solid rem(1px) $bordercolor;
          padding: rem(15px);
          margin-bottom: 0;
          border-bottom: 0;
          border-radius: 0;
          &:last-child {
              border-bottom: solid rem(1px) $bordercolor;
              @include border-radius(0, 0, rem(5px), rem(5px));
          }
          &:first-child{
              @include border-radius(rem(5px), rem(5px), 0, 0);
          }
          .panel-body, .panel-heading {
              padding: 0;
              float: left;
          }
          .panel-body {
              width: 85%;
          }
          .panel-heading {
              width: 15%;
              text-align: right;
          }
          .drag-handle {
              background: path("ic-draggable-handle.svg",images/icons) no-repeat center;
              display: inline-block;
              cursor: pointer;
              width: rem(15px);
              height: rem(17px);
          }
          label {
              margin-right: rem(10px);
          }
          input[type="text"] {
              border: none;
              outline: none;
          }
          &.ui-sortable-helper {
              border: solid rem(1px) $successcolor;
              transform: scale(1.02);
              @include border-radius(rem(5px), rem(5px), rem(5px), rem(5px));
              box-shadow: 0 8px 8px rgba(0, 0, 0, 0.05);
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/DownloadModal.vue